import { Settings, Help, Notifications, ExitToApp } from '@material-ui/icons';
import { Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import React from 'react';
import setAuthToken from '../../../utils/setAuthToken';
import { useNavigate } from 'react-router';

const Navbar = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const navigate = useNavigate();
    return (
        <nav className="d-flex justify-content-end align-items-center py-1 px-3" style={{ backgroundColor: '#F1F3F5' }}>
            <Notifications />
            <Help className="ms-3" />
            <Settings className="ms-3" />
            <IconButton
                className="ms-3"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <Avatar />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button'
                }}
            >
                <MenuItem
                    onClick={() => {
                        localStorage.removeItem('user');
                        setAuthToken(false);
                        navigate('/');
                    }}
                >
                    {' '}
                    Logout <ExitToApp className="ms-2" />
                </MenuItem>
            </Menu>
        </nav>
    );
};

export default Navbar;
